<!--  -->
<template>
  <div class="select-address">
    <div class="select-content" v-if="addressList.length">
      <div
        :class="['address-item', 'fl-align-center', addressItem.id == item.id ? 'active-address-item' : '']"
        @click="chooseItem(item)"
        v-for="item in getterAddressList"
        :key="item.id"
      >
        <span>{{ item.consigneeName }}</span
        >&nbsp; <span>{{ item.linkMobile }}</span
        >&nbsp; <span>{{ item.provinceName }} {{ item.cityName }} {{ item.regionName }} </span>&nbsp;
        <span>{{ item.address }}</span>
        <span class="default-tag" v-if="item.isDefault"></span>
      </div>
      <div class="expand-content" @click="handleExpand" v-if="addressList.length > 1">
        <span>更多 More<i :class="[isExpand ? 'expand' : 'shrink']"></i></span>
      </div>
    </div>
    <div class="to-add-adress" v-else>
      <el-button type="primary" size="default" @click="toAddAdress">添加新地址 Add new address</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    addressList: {
      type: Array,
      default: () => [],
    },
    address: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      addressItem: {},
      isExpand: false,
    };
  },
  computed: {
    getterAddressList() {
      if (this.isExpand) {
        return this.addressList;
      } else {
        return this.addressList.slice(0, 1);
      }
    },
  },
  mounted() {
    // this.getAddressList();
  },
  methods: {
    //获取收货地址
    async getAddressList() {
      const params = {
        page: 1,
        pageSize: 100,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getAddressList(params);
        this.addressList = list || [];
      } catch (error) {
        console.log(error);
      }
    },

    handleExpand() {
      this.isExpand = !this.isExpand;
    },

    chooseItem(item) {
      this.$emit("postAddress", item);
    },
    toAddAdress() {
      this.$router.push(`/my-profile/address`);
    }
  },
  watch: {
    address: {
      handler(val) {
        if (val) {
          this.addressItem = val;
          this.addressItem.id = val.deliverId;
        }
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
<style lang="scss" scoped>
.select-address {
  .address-item {
    width: 535px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #cccccc;
    margin-top: 20px;
    padding-left: 20px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    position: relative;
    &.active-address-item {
      border: 1px solid #333333;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        right: 0;
        bottom: -1px;
        width: 20px;
        height: 20px;
        background: url("~@/assets/img/checked-icon.png") 0 0 / 100% 100% no-repeat;
      }
    }
  }
  .expand-content {
    margin-top: 30px;
    span {
      display: inline-block;
      cursor: pointer;
      i {
        margin-left: 10px;
      }
      i.expand {
        background: url("~@/assets/img/more-icon.png") right center / 10px 10px no-repeat;
        transform: rotate(-180deg);
        width: 10px;
        height: 10px;
        display: inline-block;
      }
      i.shrink {
        background: url("~@/assets/img/more-icon.png") right center / 10px 10px no-repeat;
        transform: rotate(0);
        width: 10px;
        height: 10px;
        display: inline-block;
      }
    }
  }
  .default-tag {
    background: url("~@/assets/img/is-default.png") 0 0/100% 100% no-repeat;
    width: 30px;
    height: 30px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
